import React from 'react';
import { Route, IndexRoute } from 'react-router';
import ProfileForm from './profileForm';

export default (
  <Route path="profile">
    <IndexRoute component={(props) => <ProfileForm {...props} />} />
  </Route>
);
